/**
 * Auth utility — hybrid cookie + in-memory token.
 *
 * Primary: HttpOnly cookie (set by backend on /authenticate) — immune to XSS.
 * Fallback: In-memory token sent via Authorization header — for cross-origin
 *           dev scenarios where the browser rejects third-party cookies.
 *
 * The token is NEVER stored in localStorage. It lives in a module-scoped
 * variable that XSS cannot access (no window.* exposure).
 */

// Module-scoped — not accessible from console or XSS
let memoryToken = null;

export const setToken = (token) => { memoryToken = token; };
export const getToken = () => memoryToken;
export const clearToken = () => { memoryToken = null; };

export const isLoggedIn = () => !!localStorage.getItem('roles');
export const getRole = () => localStorage.getItem('roles') || '';
export const getUid = () => localStorage.getItem('uid') || '';

/** Called after successful /authenticate response */
export const onLoginSuccess = (token, roles, uid) => {
  memoryToken = token;
  localStorage.setItem('roles', roles);
  localStorage.setItem('uid', String(uid));
};

/** Called on logout — clears everything */
export const onLogout = () => {
  memoryToken = null;
  localStorage.removeItem('roles');
  localStorage.removeItem('uid');
  localStorage.removeItem('token');
};
